import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import mainContext from "../context/mainContext";
import { hasPremiumAccess } from "../utils/premiumCheck";

export default function Home() {
  const { boxesList, userTypes } = useContext(mainContext);
  const isPremium = hasPremiumAccess(userTypes);

  const checkRouteinWordTransfer = () => {
    if (boxesList.length === 0) return "/create";
    return "/wordtransfer";
  };

  return (
    <div className="container">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800 }}>جعبه‌های لایتنر</h1>
          {!isPremium && (
            <span style={{ fontSize: 12, color: "var(--warning)" }}>
              ⚡ برخی امکانات نیاز به اشتراک ویژه دارد
            </span>
          )}
        </div>
        {isPremium && (
          <span className="badge" style={{ color: "var(--success)", borderColor: "rgba(0,184,148,0.3)" }}>
            ✓ ویژه
          </span>
        )}
      </div>
      <div className="row" style={{ gap: 8, marginBottom: 16 }}>
        <Link className="btn ghost small" style={{ textDecoration: "none" }} to="/create">
          + ساخت لایتنر جدید
        </Link>
        <Link
          className="btn ghost small"
          style={{ textDecoration: "none" }}
          to={checkRouteinWordTransfer()}
          onClick={() => {
            if (boxesList.length === 0) toast.info("ابتدا جعبه لایتنر بسازید");
          }}
        >
          انتقال لغات
        </Link>
      </div>
      {boxesList.length === 0 ? (
        <div className="card empty">
          <div style={{ fontSize: 32, marginBottom: 12 }}>📦</div>
          <div style={{ marginBottom: 12 }}>هنوز جعبه لایتنری ساخته نشده است.</div>
          <Link className="btn" style={{ textDecoration: "none" }} to="/create">
            ساخت لایتنر جدید
          </Link>
        </div>
      ) : (
        <div className="grid">
          {boxesList.map((box) => (
            <div className="card" key={box._id} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div style={{ fontWeight: 700, fontSize: 16 }}>{box.name}</div>
                <span className="badge">{box.fromLang} → {box.toLang}</span>
              </div>
              {box.description && (
                <div style={{ color: "var(--text-secondary)", fontSize: 13 }}>{box.description}</div>
              )}
              <Link
                className="btn"
                style={{ textDecoration: "none", width: "100%", marginTop: "auto" }}
                to={`/box/${box._id}`}
              >
                جزئیات و مرور
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
